<template>
    <footer :class="['footer', { 'footer_homepage': homepage }]">
        <div class="footer-inner">
            <social-links></social-links>
            <div class="bs-menuStack-ft">
                <secondary-menu v-bind="{secondaryMenuItems}"></secondary-menu>
            </div>
            <div class="footer-inner-item" :data-version="versionInfo">
                {{ copyright }}
                <span v-if="isDebug" class="versionInfo">
                    - {{ versionInfo }}
                </span>
            </div>
        </div>
    </footer>
</template>

<script>
    import SocialLinks from '../common/SocialLinks.vue';
    import SecondaryMenu from './SecondaryMenu.vue';
    export default {
        props: ['homepage', 'copyright', 'versionInfo', 'isDebug', 'secondaryMenuItems'],
        components: {
            SocialLinks,
            SecondaryMenu
        }
    }
</script>

<style>
</style>

